/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputDivisionShort } from './OutputDivisionShort';
import {
    OutputDivisionShortFromJSON,
    OutputDivisionShortFromJSONTyped,
    OutputDivisionShortToJSON,
} from './OutputDivisionShort';

/**
 * 
 * @export
 * @interface OutputPosition
 */
export interface OutputPosition {
    /**
     * 
     * @type {string}
     * @memberof OutputPosition
     */
    comment?: string;
    /**
     * 
     * @type {OutputDivisionShort}
     * @memberof OutputPosition
     */
    division?: OutputDivisionShort;
    /**
     * 
     * @type {number}
     * @memberof OutputPosition
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OutputPosition
     */
    isHub?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputPosition
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputPosition
     */
    totalAmmunition?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPosition
     */
    totalDrones?: number;
}

/**
 * Check if a given object implements the OutputPosition interface.
 */
export function instanceOfOutputPosition(value: object): boolean {
    return true;
}

export function OutputPositionFromJSON(json: any): OutputPosition {
    return OutputPositionFromJSONTyped(json, false);
}

export function OutputPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'division': json['division'] == null ? undefined : OutputDivisionShortFromJSON(json['division']),
        'id': json['id'] == null ? undefined : json['id'],
        'isHub': json['isHub'] == null ? undefined : json['isHub'],
        'name': json['name'] == null ? undefined : json['name'],
        'totalAmmunition': json['totalAmmunition'] == null ? undefined : json['totalAmmunition'],
        'totalDrones': json['totalDrones'] == null ? undefined : json['totalDrones'],
    };
}

export function OutputPositionToJSON(value?: OutputPosition | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'division': OutputDivisionShortToJSON(value['division']),
        'id': value['id'],
        'isHub': value['isHub'],
        'name': value['name'],
        'totalAmmunition': value['totalAmmunition'],
        'totalDrones': value['totalDrones'],
    };
}

